module.exports = __webpack_public_path__ + "static/media/exercise.5f583474.gif";